import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import { useAuth } from '../core/Auth'
import '../../../../_metronic/assets/sass/components/twoFactorVerification.scss'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { Button } from 'react-bootstrap'
import CommonLogin from '../../../../_metronic/helpers/components/login-components/CommonLogin'
import { VERIFY_USER, RE_SEND_VERIFICATION_CODE } from '../../../../utils/GraphQLAPI'
import { useMutation } from '@apollo/client'
import mailIcon from '../../../../_metronic/images/mail.svg'
import successIcon from '../../../../_metronic/images/successIcon.svg'
import { navigateUser } from '../../../../utils/helper'
import { OtpInput } from './OtpInput'
import '../../../../_metronic/assets/sass/components/forgotPassword.scss'

const verificationCodeSchema = Yup.object().shape({
  verificationCode: Yup.number()
})

const MySwal = withReactContent(Swal)

const initialValues = {
  verificationCode: '',
}

export const Authentication = () => {
  const [loading, setLoading] = useState(false)
  const { saveAuth } = useAuth()
  const [code, setCode] = useState('')
  const [header, setHeader] = useState<string>()
  const [roles, setRoles] = useState<any>()
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [adminUserEmail, setAdminUserEmail] = useState<any>()
  const navigate = useNavigate()
  const getUserParams = useParams()
  const [userRole, setUserRole] = useState<any>()

  useEffect(() => {
    const role: any = getUserParams.adminUser
    setAdminUserEmail(localStorage.getItem('adminActivationEmail'))
    navigateUser(role, setHeader, setUserRole, setRoles);
  }, [getUserParams])

  const [accountVerification] = useMutation(VERIFY_USER, {
    onCompleted: (data) => {
      if (data.verifyUser) {
        const options: any = {
          imageUrl: successIcon,
          imageWidth: 82,
          imageHeight: 82,
          imageAlt: 'Success image',
          showConfirmButton: false,
          html: (
            <div>
              <p className='text-gray-500 fw-normal fs-4'>
                Successfully verified! You may now sign in with your username and password.
              </p>
              <Button className='btn btn-primary' onClick={() => Swal.close()}>
                Continue
              </Button>
            </div>
          ),
        }
        MySwal.fire(options).then((value) => {
          navigate(`/${getUserParams.adminUser}/login`)
        })
      }
    },
    onError: (e) => {
      setLoading(false)
      setCode('')
      setIsDisabled(true)

      MySwal.fire({
        icon: 'error',
        title: 'Verification code has expired',
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Resend Code',
        buttonsStyling: false,

        customClass: {
          popup: 'rounded-3 p-4',
          title: 'fs-3 fw-semibold text-dark mt-2 mb-4',
          confirmButton: 'btn btn-primary btn-lg w-100 text-white fw-bold px-4 py-2 rounded-1',
          closeButton: 'custom-close-btn',
          icon: 'border-danger text-danger',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          resendCode()
          setIsDisabled(false)
        }
      })
    }
  })

  // Resending the code
  const [resendVerificationCode] = useMutation(RE_SEND_VERIFICATION_CODE, {
    onCompleted: (data) => {
      if (data.reSendVerficationCodeMail === 'Email Sent Successfully!') {
        const options: any = {
          imageUrl: successIcon,
          imageWidth: 82,
          imageHeight: 82,
          imageAlt: 'Success image',
          showConfirmButton: false,
          html: (
            <div>
              <p className='text-gray-500 fw-normal fs-4'>Verification code has been sent</p>
            </div>
          ),
        }
        MySwal.fire(options)
      }
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  const formik = useFormik({
    initialValues,
    validationSchema: verificationCodeSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        await accountVerification({
          variables: {
            emailId: adminUserEmail.toLowerCase(),
            verificationCode: code,
            role: roles
          },
        })
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const handleChange = (userCode: any) => {
    setCode(userCode)
    if (userCode.length === 6) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }

  const resendCode = async () => {
    await resendVerificationCode({
      variables: {
        emailId: adminUserEmail,
        role: roles
      },
    })
  }

  return (
    <div
      className='d-flex flex-column flex-lg-row h-100 flex-column-fluid vh-100'
      style={{
        backgroundImage: 'linear-gradient(rgb(35, 56, 119), rgb(12, 20, 43))',
        backgroundSize: 'cover',
      }}
    >
      <div className='d-flex flex-column mx-10'>
        <CommonLogin role={header} userRole={userRole} />
      </div>
      <div className='d-flex align-items-center justify-content-center flex-lg-row-fluid w-50 mt-5 '>
        <div className='card card-custom px-12 py-12 ml-5 bg-white w-550px'>
          <div className='d-flex justify-content-center'>
            <img src={mailIcon} alt='' />
          </div>
          <form
            className='form'
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'
          >
            <div className='mt-5'>
              <div className='text-center'>
                <h1 className='text-black fw-700 mb-5'>Two Step Verification</h1>
              </div>
              <div>
                <p className='text-color-grey fw-semibold fs-6 text-center mb-3'>
                  Enter the verification code sent to your email <br />
                  <span className='text-color-black fw-bold fs-5'>
                    {adminUserEmail}
                  </span>
                </p>
              </div>
            </div>
            <OtpInput code={code} handleChange={handleChange} />
            {/* begin::Action */}
            <div className='d-flex mb-5 align-items-center justify-content-center'>
              <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-primary btn-lg w-100'
                disabled={formik.isSubmitting || !formik.isValid || isDisabled}
              >
                {!loading && <span className='indicator-label'>Verify</span>}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* end::Action */}
            <div className='text-color-grey text-center fw-semibold fs-6 pb-0'>
              Didn't get the code?
              <button
                type="button"
                onClick={resendCode}
                className="btn btn-link fw-bold fs-5 mx-2 p-0 text-decoration-none custom-blue">
                Resend
              </button>
              <div className='text-center mb-6'>
                <p className='text-danger fw-bold fs-6 mb-1'>
                  This code will expire within 10 minutes.
                </p>
                <p className='text-danger fw-bold fs-6 mb-1'>
                  Use the Resend button above if it has expired.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
